import { useState } from "react";
import { useRouter } from "@miplatform/hooks";
import { IHome } from "@miplatform/types";

export const useHomesAddHomeDrawer = () => {
  const { navigate } = useRouter();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const handleAfterHomeCreation = (home: IHome): void => {
    handleDrawerClose();
    navigate(`/homes/${home?.id}`);
  };

  return {
    isDrawerOpen,
    handleDrawerOpen,
    handleDrawerClose,
    handleAfterHomeCreation,
  };
};
